<template>
    <div class="max-width-content">
        <trashed-message v-if="tag.deleted_at" class="mb-6" @restore="restore">
            This tag has been deleted.
        </trashed-message>

        <breadcrumbs>
            <inertia-link href="/tags">Tags</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.tags.show', tag.id)">{{ tag.name | truncate(35) }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <tag-form :tag="tag" @submit="submit" :categories="categories" :data-loading="loading"></tag-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import TagForm from "@/admin/Pages/Tags/TagForm";

export default {
    metaInfo() {
        return { title: this.tag.name };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        TagForm
    },

    mixins: [Helpers],

    props: {
        tag: Object,
        categories: Array
    },

    data() {
        return {
            form: {
                name: this.tag.name,
                seotext1: this.tag.seotext1,
                seotext2: this.tag.seotext2
            }
        };
    },

    methods: {
        submit(form) {
            this.loading = "submit";
            const url = this.route("admin.tags.update", this.tag.id)
            const options = { onFinish: () => this.loading = false }

            this.$inertia.patch(url, form, options);
        }
    }
};
</script>
